import React from 'react'; 
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import TextBox from '../Basic/TextBox';
import Select from '../Basic/Select';
import SectionHeader from '../Basic/SectionHeader';
import util from '../../lib/util';
import * as consts from '../../constants';
class Address2 extends React.Component {
  componentWillMount() {
    if (this.props.address) {
      this.props.dispatchAddress(this.props.address);
    }
  }
  componentWillReceiveProps(newProps) {
    if (newProps.address && this.props.address !== newProps.address && (this.props.address && this.props.address.unitNumber) !== (newProps.address && newProps.address.unitNumber)) {
      this.props.dispatchAddress(newProps.address);
    }
  }
  render() {
    const p = this.props;
    const streetDirection = window.osa && window.osa.commonLookup.streetDirection;
    const streetType = (window.osa && window.osa.streetTypes || []);
    return (
      <div className="form-group">
        <SectionHeader title={p.title} />
        <div className="row">
          <div className="col-md-2">
            <TextBox id={p.name + '_unitNumber'} name={p.name + '_unitNumber'} title="Unit number" maxLength={10} disabled={p.disabled} />
          </div>
          <div className="col-md-3">
            <TextBox id={p.name + '_streetNumber'} name={p.name + '_streetNumber'} title="Street number" disabled={p.disabled} required maxLength={10} />
          </div>
          <div className="col-md-3">
            <Select name={p.name + '_streetDirection'} title="Street direction" items={streetDirection}
              placeHolder="Please select" disabled={p.disabled} isControl />
          </div>
          <div className="col-md-4">
            <TextBox id={p.name + '_streetName'} name={p.name + '_streetName'} title="Street name" disabled={p.disabled} required maxLength={60} />
          </div>
        </div>
        <div className="row">
          <div className="col-md-2">
            <Select name={p.name + '_streetType'} title="Street type" items={streetType}
              placeHolder="Please select" disabled={p.disabled} isControl />
          </div>
          <div className="col-md-3">
            <TextBox id={p.name + '_city'} name={p.name + '_city'} title="City" disabled={p.disabled} required />
          </div>
          <div className="col-md-3">
            <Select name={p.name + '_state'} title="Province" items={[{ id: "BC", name: "British Columbia" }]}
              disabled={p.disabled} isControl required />
          </div>
          <div className="col-md-4">
            <TextBox id={p.name + '_zip'} name={p.name + '_zip'} title="Postal code" pattern={consts.REGEX_POSTALCODE} disabled={p.disabled} required />
          </div>
        </div>
      </div>
    );
  }
}
Address2.propTypes = {
  name: PropTypes.string.isRequired,
  address: PropTypes.object,
  disabled: PropTypes.bool
};
const mapsDispatchToProps = (dispatch, props) => {
  return {
    dispatchAddress: (address) => (dispatch({ type: 'SET_ADDRESS', name: props.name, address }))
  };
};
export default connect(null, mapsDispatchToProps)(Address2);

export function Address2Validation(name) {
  return [
    [name + "_streetNumber", p => p[name + "_streetNumber"], "Street number"],
    [name + "_streetName", p => p[name + "_streetName"], "Street name"],
    [name + "_city", p => p[name + "_city"], "City"],
    // [name + "_country", p => p[name + "_country"], "Country"],
    [name + "_state", p => p[name + "_state"], "Province/state"],
    [name + "_zip", p => p[name + "_zip"], "Postcode/zip"],
    [name + "_zip", p => !p[name + "_zip"] || util.isPostalCodeValid(p[name + "_zip"]), "Postal code"],
  ];

}